import { Text, View, Image, Link, StyleSheet } from '@react-pdf/renderer';
import { IAttendanceDeclarationResponse } from '../../../../../services/schedule.service';
import { formatDateLabel, formatOnlyDate, formatOnlyHour } from '../../../../../lib/dayjs';
import LogoImage from '../../../../../images/logo-icon.png';

export default function PDFDocument(data: IAttendanceDeclarationResponse) {
  const styles = StyleSheet.create({
    logo: {
      width: 25,
      height: 25,
      marginBottom: 20
    },
    header: {
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '136%' /* 21.76px */
    },
    h1: {
      fontSize: 20,
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '136%' /* 27.2px */
    },
    divider: {
      backgroundColor: '#A7DBC4',
      width: '100%',
      height: 1
    },
    link: {
      textAlign: 'center',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '136%' /* 21.76px */,
      '&:visited': {
        color: '#0C3B49'
      }
    },
    space20: {
      marginBottom: 20
    },
    space10: {
      marginBottom: 10
    }
  });

  const link = {
    label: process.env.REACT_APP_STAGE
      ? 'minhaconta.oya.care/declaracao-de-comparecimento'
      : 'minha-conta-qa.oya.care/declaracao-de-comparecimento',
    href: process.env.REACT_APP_STAGE
      ? 'https://minhaconta.oya.care/declaracao-de-comparecimento'
      : 'https://minha-conta-qa.oya.care/declaracao-de-comparecimento'
  };
  return (
    <>
      <Image src={LogoImage} style={styles.logo} />
      <Text> OYA CARE</Text>
      <Text style={styles.space20}> CNPJ: 38.067.381/0001-07</Text>
      <View style={{ ...styles.divider, ...styles.space20 }} />
      <Text style={{ ...styles.space20, ...styles.h1 }}>Declaração de Comparecimento</Text>

      <Text style={styles.space20}>{data.patient.fullName}</Text>
      <Text style={styles.space20}>{data.patient.cpf}</Text>
      <Text style={styles.space10}>Esteve presente no dia {formatOnlyDate(data.schedule.dateStart)}</Text>
      <Text style={styles.space20}>das {formatOnlyHour(data.schedule.dateStart, data.schedule.dateEnd)}</Text>
      <Text style={styles.space20}>para atendimento previamente agendado em: </Text>
      <Text style={styles.space20}>
        {data.calendar.location || 'para atendimento previamente agendado junto à Oya Care.'}
      </Text>

      <Text style={styles.space20}>
        Este documento foi gerado automaticamente pelo sistema da clínica, com base em registros eletrônicos de presença, não
        sendo necessária assinatura manuscrita. Documento pessoal e intransferível.
      </Text>
      <View style={{ ...styles.divider, ...styles.space20 }} />
      <Text style={styles.space20}>Emitido em: {formatDateLabel(data.createdAt)}</Text>
      <Text style={{ ...styles.space20, ...styles.h1 }}>Código de validação: {data.code}</Text>
      <Text style={styles.space20}>
        Valide em:{' '}
        <Link src={link.href} style={styles.link}>
          {link.label}
        </Link>
      </Text>
    </>
  );
}
